const Loader = (state = false, action = {}) => {
    switch (action.type) {
        case "SET_LOADER_STATUS":
            return action.loading;
        default:
            return state;
    }
};

export default Loader;
  